import React from "react";
import { Box } from "@chakra-ui/react";
import { PreAnestheticExam, PhysicalExam } from "./components";

const PreAnesthetic: React.FC = () => (
  <>
    <PreAnestheticExam />
    <Box mt={12}>
      <PhysicalExam />
    </Box>
  </>
);

export default PreAnesthetic;
